import React from 'react';
import BikeCard from 'components/BikeCard';
import OfferBanner from 'components/OfferBanner';
import FinanceOptions from 'components/FinanceOptions';
import { useSelector } from 'react-redux';
import { getBikeModel, getFinanceOptions, getFinanceOptionContent, getOfferBanner } from 'src/redux/app/selectors';

const StepOne = () => {
  const bikeModel = useSelector(getBikeModel);
  const financeOptions = useSelector(getFinanceOptions);
  const financeOptionContent = useSelector(getFinanceOptionContent);
  const offerBanner = useSelector(getOfferBanner);

  return (
    <>
      <BikeCard bikeModel={bikeModel}></BikeCard>
      {offerBanner && <OfferBanner offerBanner={offerBanner}></OfferBanner>}
      <FinanceOptions
        financeOptions={financeOptions}
        financeOptionContent={financeOptionContent}
        bikeModel={bikeModel}
      ></FinanceOptions>
    </>
  );
};

export default StepOne;
